import React, { useState } from "react";
import { toast } from "react-toastify";
import { copyText } from "./showcaseSetupModel";

const CodeBox = ({ code, label = "Copy" }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    if (!code) return;
    if (await copyText(code)) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } else toast.error("Copy did not work. Select the text and copy it by hand.");
  };
  return (
    <div className="showcase-setup__code">
      <pre>
        <code>{code || "Your code is being prepared."}</code>
      </pre>
      <button type="button" className="showcase-setup__copy" onClick={copy} disabled={!code}>
        {copied ? "Copied" : label}
      </button>
    </div>
  );
};

export default CodeBox;
